import {useMatchMedia} from '@pexip/hooks';

import {SM_DOWN} from '../../constants/mediaQueries';

export const useSmDown = () => useMatchMedia(SM_DOWN);
